import { createFileRoute } from '@tanstack/react-router';
import { Meetings } from '@/components/Modules/Meetings';

export const Route = createFileRoute('/meetings')({
  component: Meetings,
});
